exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-strip[data-v-0719702c]{gap:6px}", ""]);

// exports
